import { DownloadableFile } from './Media';

export const isDownloadableFile = (value: unknown): value is DownloadableFile => (
    typeof value === 'object'
    && value !== null
    && 'src' in value
    && 'title' in value
);
